import Stack from '@mui/material/Stack';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import { EMPTY_OBJECT } from '@e-socna/empty';
import type { FragmentType } from '@e-socna/data-layer';

import { KeyValueTable } from './KeyValueTable';
import { NoData } from './Illustrations/NoData';
import { EmailAddress } from './EmailAddress';
import { LinkToNewTab } from './LinkToNewTab';
import { PhoneNumber } from './PhoneNumber';

export const ContactInfoCmp_ContactInfo_Fragment = graphql(`
  fragment ContactInfoCmp_ContactInfo_Fragment on ContactInfo {
    email
    mobileNumber
    landlineNumber
    professionalNumber
    faxNumber
    website
  }
`);

interface Props {
  readonly compact?: boolean;
  readonly contactInfo?: FragmentType<
    typeof ContactInfoCmp_ContactInfo_Fragment
  > | null;
}

export const ContactInfo = ({
  compact = false,
  contactInfo: pContactInfo,
}: Readonly<Props>) => {
  const contactInfo = getFragmentData(
    ContactInfoCmp_ContactInfo_Fragment,
    pContactInfo,
  );

  if (
    !contactInfo ||
    (!contactInfo.email &&
      !contactInfo.mobileNumber &&
      !contactInfo.landlineNumber &&
      !contactInfo.professionalNumber &&
      !contactInfo.faxNumber &&
      !contactInfo.website)
  ) {
    return <NoData />;
  }

  return (
    <Stack sx={{ ...(!compact ? { pt: 4 } : EMPTY_OBJECT), width: '100%' }}>
      <KeyValueTable
        ariaLabel="Informations de contact"
        entries={[
          {
            id: 'email',
            label: compact ? 'Mail' : 'Adresse e-mail',
            value: <EmailAddress eMail={contactInfo.email} />,
          },
          {
            id: 'mobile',
            label: compact ? 'Port' : 'Numéro téléphone portable',
            value: <PhoneNumber phoneNumber={contactInfo.mobileNumber} />,
          },
          {
            id: 'landline',
            label: compact ? 'Fixe' : 'Numéro téléphone fixe',
            value: <PhoneNumber phoneNumber={contactInfo.landlineNumber} />,
          },
          {
            id: 'pro',
            label: compact ? 'Pro' : 'Numéro téléphone professionnel',
            value: <PhoneNumber phoneNumber={contactInfo.professionalNumber} />,
          },
          {
            id: 'fax',
            label: compact ? 'Fax' : 'Numéro de fax',
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            value: contactInfo.faxNumber || 'Inconnu',
          },
          {
            id: 'website',
            label: compact ? 'Site' : 'Site internet',
            value: <LinkToNewTab href={contactInfo.website} />,
          },
        ]}
      />
    </Stack>
  );
};
